import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useMemo, useRef, useState } from 'react';
import { noop } from '../utils/noop';
export function useIntersectionObserver(params) {
  var _params$deps = params.deps,
    deps = _params$deps === void 0 ? [] : _params$deps,
    elementRef = params.elementRef,
    _params$initSubscribe = params.initSubscribeAvailable,
    initSubscribeAvailable = _params$initSubscribe === void 0 ? true : _params$initSubscribe,
    observerOptions = params.observerOptions,
    _params$onChange = params.onChange,
    onChange = _params$onChange === void 0 ? noop : _params$onChange,
    _params$onInViewport = params.onInViewport,
    onInViewport = _params$onInViewport === void 0 ? noop : _params$onInViewport,
    _params$onOutViewport = params.onOutViewport,
    onOutViewport = _params$onOutViewport === void 0 ? noop : _params$onOutViewport;
  var subscribeAvailableRef = useRef(initSubscribeAvailable);
  var intersectionsCount = useRef({
    inView: 0,
    outView: 0
  });
  var _useState = useState(initSubscribeAvailable),
    _useState2 = _slicedToArray(_useState, 2),
    isSubscribeAvailable = _useState2[0],
    setIsSubscribeAvailable = _useState2[1];
  var subscribeState = useMemo(function () {
    return {
      setSubscribeAvailable: function setSubscribeAvailable() {
        subscribeAvailableRef.current = true;
        setIsSubscribeAvailable(true);
      },
      setSubscribeUnavailable: function setSubscribeUnavailable() {
        subscribeAvailableRef.current = false;
        setIsSubscribeAvailable(false);
      },
      get subscribeAvailable() {
        return subscribeAvailableRef.current;
      }
    };
  }, []);
  useEffect(function () {
    if (isSubscribeAvailable && elementRef.current) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          intersectionsCount.current.inView += 1;
          onInViewport({
            entries: entries,
            intersectionsCount: intersectionsCount.current,
            observer: observer,
            subscribeState: subscribeState
          });
        } else {
          intersectionsCount.current.outView += 1;
          onOutViewport({
            entries: entries,
            intersectionsCount: intersectionsCount.current,
            observer: observer,
            subscribeState: subscribeState
          });
        }
        onChange({
          entries: entries,
          intersectionsCount: intersectionsCount.current,
          observer: observer,
          subscribeState: subscribeState
        });
      }, observerOptions);
      observer.observe(elementRef.current);
      return function () {
        observer.disconnect();
      };
    }
  }, deps.concat(isSubscribeAvailable));
  return {
    subscribeState: subscribeState
  };
}